export const getMonthsPerView = () => {
  const cappedScreenWidth = Math.min(1450, window.innerWidth);

  const contentWidth = Math.max(0, cappedScreenWidth - 800);

  const items = Math.floor(contentWidth / 100);

  return Math.max(1, items);
};
